import React, { useState } from 'react';
import { Container, Table, Badge } from 'react-bootstrap';

const LiveTransaction = () => {
  // Sample data generator for live transactions
  const generateSampleData = () => {
    const userRoles = [
      'Super Distributor',
      'Master Distributor',
      'Distributor',
      'Retailer',
      'API Partner'
    ];
    const types = ['Credit', 'Debit'];
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi',
      'Suresh Yadav', 'Kavita Mehta', 'Arun Kumar', 'Pooja Singh',
      'Deepak Sharma', 'Ritu Agarwal', 'Manoj Tiwari', 'Swati Desai',
      'Sanjay Rao', 'Meera Nair', 'Karan Khanna', 'Divya Saxena'
    ];

    // Generate 50 live transactions
    const now = new Date();
    return Array.from({ length: 50 }, (_, i) => {
      const transactionDate = new Date(now.getTime() - Math.random() * 2 * 60 * 60 * 1000);
      const hours = transactionDate.getHours().toString().padStart(2, '0');
      const minutes = transactionDate.getMinutes().toString().padStart(2, '0');
      const seconds = transactionDate.getSeconds().toString().padStart(2, '0');

      return {
        id: `TXN${String(100000 + i).toString()}`,
        userName: names[Math.floor(Math.random() * names.length)],
        type: types[Math.floor(Math.random() * types.length)],
        amount: [500, 1000, 2000, 5000, 10000, 15000, 20000, 25000][
          Math.floor(Math.random() * 8)
        ],
        transactionDate: transactionDate.toISOString().split('T')[0],
        time: `${hours}:${minutes}:${seconds}`,
        status: 'Live'
      };
    });
  };

  const [transactionsData] = useState(generateSampleData());

  const getTypeBadge = (type) => {
    return type === 'Credit' ? 'success' : 'danger';
  };

  return (
    <Container fluid className="p-3" style={{ height: 'calc(100vh - 100px)' }}>
      <style>
        {`
          @keyframes blink {
            0%, 50%, 100% { opacity: 1; }
            25%, 75% { opacity: 0.3; }
          }
          .live-indicator {
            animation: blink 2s infinite;
          }
          .live-transactions-table {
            height: calc(100vh - 150px);
            overflow-y: auto;
            overflow-x: hidden;
          }
          .live-transactions-table::-webkit-scrollbar {
            width: 0px;
            display: none;
          }
          .live-transactions-table {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .live-transactions-table thead {
            position: sticky;
            top: 0;
            z-index: 10;
          }
          .live-transactions-table thead th {
            background: #f0f2f5 !important;
            border-bottom: 2px solid #dee2e6;
            position: sticky;
            top: 0;
          }
        `}
      </style>

      {/* Live Indicator */}
      <div className="d-flex justify-content-start align-items-center mb-3 gap-2">
        <div className="live-indicator" 
             style={{
               width: '12px',
               height: '12px',
               borderRadius: '50%',
               backgroundColor: '#00ff00',
               boxShadow: '0 0 15px #00ff00'
             }}>
        </div>
        <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#495057' }}>Live</span>
      </div>

      {/* Table */}
      <div className="live-transactions-table" style={{ background: '#f0f2f5', borderRadius: '12px', padding: '0' }}>
        <Table bordered hover className="modern-table mb-0" style={{ background: '#f0f2f5' }}>
          <thead>
            <tr>
              <th style={{ fontWeight: '600' }}>Transaction ID</th>
              <th style={{ fontWeight: '600' }}>User Name</th>
              <th style={{ fontWeight: '600' }}>Type</th>
              <th style={{ fontWeight: '600' }}>Amount (₹)</th>
              <th style={{ fontWeight: '600' }}>Date</th>
              <th style={{ fontWeight: '600' }}>Time</th>
            </tr>
          </thead>
          <tbody>
            {transactionsData.map((row, index) => (
              <tr key={index} style={{ background: '#f0f2f5' }}>
                <td>{row.id}</td>
                <td>{row.userName}</td>
                <td>
                  <Badge bg={getTypeBadge(row.type)}>
                    {row.type}
                  </Badge>
                </td>
                <td className="fw-bold text-success">₹{row.amount.toLocaleString()}</td>
                <td>{row.transactionDate}</td>
                <td className="fw-bold text-primary">{row.time}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default LiveTransaction;

